import { render, staticRenderFns } from "./error-modal-template.vue?vue&type=template&id=66c613a6&"
import script from "./error-modal-template.vue?vue&type=script&lang=js&"
export * from "./error-modal-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports